import { useContext, useEffect, useState } from "react";
import CreateGroup from "./ui/CreateGroup";
import { GlobalContext } from "../contexts/GlobalContext";
import { snackBarConfigType } from "../classes/SnackBarConfig";
import CustomSnackbar from "./ui/CustomSnackbar";
import {
  CircularProgress,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { fetchUserGroups } from "../services/firebase";
import { useNavigate } from "react-router-dom";

const Group = () => {
  const navigate = useNavigate();
  const { currentUser, getCurrentUser } = useContext(GlobalContext);
  const [groups, setGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  let [snackBarConfig, setSnackBarConfig] = useState<snackBarConfigType>({
    open: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    const loadGroups = async () => {
      if (!currentUser?.id) return;
      setLoading(true);

      try {
        const fetchedGroups = await fetchUserGroups(currentUser.id);
        setGroups(fetchedGroups);
      } catch (error) {
        setSnackBarConfig({
          open: true,
          severity: "error",
          message: "Failed to load groups.",
        });
      }
      setLoading(false);
    };

    loadGroups();
  }, [currentUser?.id]);

  /*  setSnackBarConfig({
        open: true,
        severity: "error",
        message: "Invalid Progress Range!",
      }); */
  return (
    <>
      <CustomSnackbar snackbarConfig={snackBarConfig} />
      <div className="mx-4 my-10">
        <h1 className="font-grgrifter text-[2.8rem] tracking-wider text-[#AFAEB3] mb-10 w-full text-center">
          Groups
        </h1>

        <div className="flex flex-col gap-6">
          <div>
            <button
              className=" flex items-left justify-left px-3 py-2 rounded-[2em] cursor-pointer ml-2"
              type="submit"
              onClick={() => navigate("/home")}
            >
              {/* <ShowIcon size={18} className="mr-2" color="#3A9437" /> */}
              <p className="font-grgrifter text-sm tracking-widest text-left text-gray-500">
                {"< Back"}
              </p>
            </button>
            <CreateGroup userId={currentUser.id} />
          </div>
          {/* Groups Table */}
          <div className="mt-6">
            <h2 className="text-2xl text-[#1B1B1B] mb-4">Your Groups</h2>

            {loading ? (
              <div className="flex justify-center">
                <CircularProgress />
              </div>
            ) : groups.length === 0 ? (
              <p className="text-gray-500">
                You are not part of any groups yet.
              </p>
            ) : (
              <TableContainer
                component={Paper}
                sx={{ borderRadius: "26px", boxShadow: "none" }}
              >
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#3A9437" }}>
                      <TableCell sx={{ color: "white", fontWeight: "" }}>
                        Group Name
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", fontWeight: "" }}
                        align="right"
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groups.map((group) => (
                      <TableRow
                        key={group.id}
                        sx={
                          {
                            //   "&:nth-of-type(odd)": { backgroundColor: "#f4f4f7" },
                          }
                        }
                      >
                        <TableCell>{group.name}</TableCell>
                        <TableCell align="right">
                          <Button
                            variant="contained"
                            size="small"
                            sx={{
                              backgroundColor: "#3A9437",
                              borderRadius: "12px",
                              boxShadow: "none",
                              "&:hover": { backgroundColor: "#2d6d29" },
                            }}
                            onClick={() => navigate("/group/" + group.id)}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Group;
